import React from 'react';
import I18n from 'i18n-js';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import { RCIcon } from '@reverbdotcom/cadence/components';
import { TrophyIcon } from '@reverbdotcom/cadence/icons/react';
import { SellerListingCardFragment } from '@reverbdotcom/commons/src/gql/graphql';

import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { cspPath } from '@reverbdotcom/commons/src/url_helpers';
import { RCTextUtility } from '@reverbdotcom/cadence/components/RCText/RCText';
import { getCompetitorCount } from '../bump/bump_helpers';
import { buildClickedEvent, INSIGHT, useTrackingContext, useTrackImpression } from './sellerRecommendationTracking';

interface Props {
  listing: SellerListingCardFragment;
}

export const COMPONENT_NAME = 'TopPickWinnerPresentment';

export default function TopPickWinnerPresentment({ listing }: Props) {
  const competitorCount = getCompetitorCount(listing);
  const cspSlug = listing.csp?.slug;
  const trackingContext = useTrackingContext();

  useTrackImpression(COMPONENT_NAME, INSIGHT.TOP_PICK_WINNER, listing.id);

  return (
    <div className="seller-listing-insight-presentment">
      <span className="seller-listing-insight-presentment__top-pick-winner">
        <RCIcon icon={<TrophyIcon />} size="inline-prominent" spacing="right" color="text-success" />
        <span className="weight-bold">
          {I18n.t('discovery.listingsManagement.sellerListingCard.insights.topPickWinner.title')}
        </span>
      </span>
      <RCTextUtility size="350">
        {I18n.t('discovery.listingsManagement.sellerListingCard.insights.topPickWinner.featuredPlacement')}{' '}
        {cspSlug ? (
          <span className="weight-semibold">
            <CoreLink
              to={cspPath(cspSlug)}
              className="text-link"
              target="_blank"
              rel="noreferrer"
              clickEvent={buildClickedEvent(COMPONENT_NAME, INSIGHT.TOP_PICK_WINNER, listing.id, trackingContext)}
            >
              {I18n.t('discovery.listingsManagement.sellerListingCard.insights.topPickWinner.productPageLink')}
            </CoreLink>
          </span>
        ) : (
          <span>
            {I18n.t('discovery.listingsManagement.sellerListingCard.insights.topPickWinner.productPage')}
          </span>
        )}
      </RCTextUtility>
      {competitorCount > 0 && (
        <RCTextUtility size="350">
          <Translate text="discovery.listingsManagement.sellerListingCard.insights.topPickWinner.outrankingCompetitors" args={{ count: competitorCount.toString() }}>
            <span className="weight-semibold">{competitorCount}</span>
          </Translate>
        </RCTextUtility>
      )}
    </div>
  );
}
